// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/editor/v1/editor.proto" (package "c1.api.editor.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { EditorService } from "./editor";
import type { EditorServiceGetCELSchemaResponse } from "./editor";
import type { EditorServiceGetCELSchemaRequest } from "./editor";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { EditorServiceValidateCELResponse } from "./editor";
import type { EditorServiceValidateCELRequest } from "./editor";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.editor.v1.EditorService
 */
export interface IEditorServiceClient {
    /**
     * @generated from protobuf rpc: ValidateCEL(c1.api.editor.v1.EditorServiceValidateCELRequest) returns (c1.api.editor.v1.EditorServiceValidateCELResponse);
     */
    validateCEL(input: EditorServiceValidateCELRequest, options?: RpcOptions): UnaryCall<EditorServiceValidateCELRequest, EditorServiceValidateCELResponse>;
    /**
     * @generated from protobuf rpc: GetCELSchema(c1.api.editor.v1.EditorServiceGetCELSchemaRequest) returns (c1.api.editor.v1.EditorServiceGetCELSchemaResponse);
     */
    getCELSchema(input: EditorServiceGetCELSchemaRequest, options?: RpcOptions): UnaryCall<EditorServiceGetCELSchemaRequest, EditorServiceGetCELSchemaResponse>;
}
/**
 * @generated from protobuf service c1.api.editor.v1.EditorService
 */
export class EditorServiceClient implements IEditorServiceClient, ServiceInfo {
    typeName = EditorService.typeName;
    methods = EditorService.methods;
    options = EditorService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ValidateCEL(c1.api.editor.v1.EditorServiceValidateCELRequest) returns (c1.api.editor.v1.EditorServiceValidateCELResponse);
     */
    validateCEL(input: EditorServiceValidateCELRequest, options?: RpcOptions): UnaryCall<EditorServiceValidateCELRequest, EditorServiceValidateCELResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<EditorServiceValidateCELRequest, EditorServiceValidateCELResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCELSchema(c1.api.editor.v1.EditorServiceGetCELSchemaRequest) returns (c1.api.editor.v1.EditorServiceGetCELSchemaResponse);
     */
    getCELSchema(input: EditorServiceGetCELSchemaRequest, options?: RpcOptions): UnaryCall<EditorServiceGetCELSchemaRequest, EditorServiceGetCELSchemaResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<EditorServiceGetCELSchemaRequest, EditorServiceGetCELSchemaResponse>("unary", this._transport, method, opt, input);
    }
}
